import { LOADING_STATES } from 'src/utils/maps';
import { produce } from 'immer';
import { MY_PETS_CONSTANTS } from 'src/modules/my-pets/constants/my-pets';

const initialState = {
  data: [],
  status: LOADING_STATES.LOADING,
  error: null,
  page: 0,
  firstLoad: true,
  isMore: true,
};

const myPetsReducer = (state = initialState, action) => produce(state, draft => {
  switch (action.type) {
    case MY_PETS_CONSTANTS.setMyPets:
      draft.data = [...state.data, ...action.payload];
      break;
    case MY_PETS_CONSTANTS.setPage:
      draft.page = action.payload;
      break;
    case MY_PETS_CONSTANTS.setStatus:
      draft.status = action.payload;
      break;
    case MY_PETS_CONSTANTS.setFirstLoad:
      draft.firstLoad = action.payload;
      break;
    case MY_PETS_CONSTANTS.setIsMore:
      draft.isMore = action.payload;
      break;
    case MY_PETS_CONSTANTS.resetMyPets:
      return initialState;
    default:
      break;
  }
});

export default myPetsReducer;
